import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-dialog-close',
  styleUrls: ['./dialog-close.component.less'],
  template: `
    <rt-icon-button
      variant="plain-onoverlay"
      [rtTooltip]="closeTooltip! | translate"
      [rtTooltipPosition]="'left'"
      iconName="close"
      shape="square"
    >
    </rt-icon-button>
  `,
})
export class DialogCloseComponent {
  @Input() public closeTooltip?: string = 'rtu.dialog.close_tooltip';
}
